/**
 * The hatch: 2px stripes every 6px at 45° over a ground (m3-shape-deficit-hatch.md).
 * One definition per consumer, drawn by the chart and by its legend key, so the key
 * is the bar's texture and not a lookalike. A fill reaches it through a custom
 * property naming `url(#id)` on the owning svg. Colour lives in the class rules the
 * consumer supplies, never here.
 */
export function HatchPattern({
  id,
  groundClass,
  stripeClass,
}: {
  id: string
  groundClass: string
  stripeClass: string
}) {
  return (
    <pattern id={id} patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
      <rect className={groundClass} width="6" height="6" />
      <rect className={stripeClass} width="2" height="6" />
    </pattern>
  )
}
